function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;


//////////////////
// WEBPACK FOOTER
// ./~/downshift/~/@babel/runtime/helpers/inheritsLoose.js
// module id = 1004
// module chunks = 0